import React from 'react';


export const Django = props => {
    return (
        <img className={props.className} src={require('../../../resources/images/png_icons/django.png')} />
    )
};
